import React, { Component, Fragment } from 'react'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { preRegistrationsActions, messageActions } from '../../../actions'
import TextField from '@material-ui/core/TextField'
import SelectWrapped from '../../../components/SelectWrapped'
import { formatContentSelectValue, filterOptionsFunction } from '../../../utils'
import Typography from '@material-ui/core/Typography'
import * as API from '../../../api'
import { readOnly } from '../../../utils/permissions'

import { IsbnField, EdicaoField, CopyrightField } from '../../../components/Fields'

const styles = theme => ({
  layout: {
    height: 'calc(100% - 64px)',
    position: 'relative'
  },
  preRegistrationForm: {
    background: '#fff',
    height: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing.unit * 3,
    overflow: 'auto'
  },
  formGroup: {
    padding: '12px 0'
  },
  formControl: {
    margin: '12px 0'
  },
  uploadButton: {
    margin: '15px 0',
    padding: '0 16px',
    background: 'rgb(0, 45, 114)',
    color: '#fff'
  },
  uploadButtonIcon: {
    color: 'inherit !important',
    marginLeft: '3px'
  },
  formSelect: {
    marginTop: '23px',
    paddingBottom: '12px'
  }
})

class Livro extends Component {
  render() {
    const {
      classes,
      preRegistration,
      handleChangePreRegistration,
      preRegistrationFormErrors,
      formTouched,
      token
    } = this.props

    const isReadOnly = readOnly(preRegistration.tipo, token)

    return (
      <Fragment>
        <FormControl
          error={!((preRegistrationFormErrors.fields || {})['titulo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-titulo">Título</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangePreRegistration({ ...preRegistration, titulo: e.target.value })
            }}
            value={preRegistration.titulo}
            id="field-titulo"
          />
          {!((preRegistrationFormErrors.fields || {})['titulo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((preRegistrationFormErrors.fields || {})['titulo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <div className={classes.formSelect}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangePreRegistration({ ...preRegistration, autores: obj })
            }}
            error={
              !((preRegistrationFormErrors.fields || {})['autores'] || {}).valid && formTouched
            }
            value={formatContentSelectValue(preRegistration.autores || [])}
            placeholder="Selecione..."
            name="react-select-chip-autores"
            label="Autores"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-autores',
                loadOptions: API.authors.getSelectAuthors,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((preRegistrationFormErrors.fields || {})['autores'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((preRegistrationFormErrors.fields || {})['autores'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <div className={classes.formSelect}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangePreRegistration({ ...preRegistration, especialidades: obj })
            }}
            error={
              !((preRegistrationFormErrors.fields || {})['especialidades'] || {}).valid &&
              formTouched
            }
            value={formatContentSelectValue(preRegistration.especialidades || [])}
            placeholder="Selecione..."
            name="react-select-chip-especialidades"
            label="Especialidades"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-especialidades',
                loadOptions: API.specialities.getSelectSpecialities,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((preRegistrationFormErrors.fields || {})['especialidades'] || {}).valid &&
          formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((preRegistrationFormErrors.fields || {})['especialidades'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((preRegistrationFormErrors.fields || {})['isbn'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-isbn">ISBN</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={IsbnField}
            onChange={e => {
              handleChangePreRegistration({ ...preRegistration, isbn: e.target.value })
            }}
            value={preRegistration.isbn || ''}
            id="field-isbn"
          />
          {!((preRegistrationFormErrors.fields || {})['isbn'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((preRegistrationFormErrors.fields || {})['isbn'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((preRegistrationFormErrors.fields || {})['codigo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-codigo">Código Protheus</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={IsbnField}
            onChange={e => {
              handleChangePreRegistration({ ...preRegistration, codigo: e.target.value })
            }}
            value={preRegistration.codigo || ''}
            id="field-codigo"
          />
          {!((preRegistrationFormErrors.fields || {})['codigo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((preRegistrationFormErrors.fields || {})['codigo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={
            !((preRegistrationFormErrors.fields || {})['copyright'] || {}).valid && formTouched
          }
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-copyright">Ano copyright</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            inputComponent={CopyrightField}
            onChange={e => {
              handleChangePreRegistration({ ...preRegistration, copyright: e.target.value })
            }}
            value={preRegistration.copyright || ''}
            id="field-copyright"
          />
          {!((preRegistrationFormErrors.fields || {})['copyright'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((preRegistrationFormErrors.fields || {})['copyright'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((preRegistrationFormErrors.fields || {})['edicao'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-edicao">Edição</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={EdicaoField}
            onChange={e => {
              handleChangePreRegistration({ ...preRegistration, edicao: e.target.value })
            }}
            value={preRegistration.edicao || ''}
            id="field-edicao"
          />
          {!((preRegistrationFormErrors.fields || {})['edicao'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((preRegistrationFormErrors.fields || {})['edicao'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    preRegistration: state.preRegistrations.preRegistration,
    preRegistrationFormErrors: state.preRegistrations.preRegistrationFormErrors,
    formTouched: state.preRegistrations.preRegistrationFormTouched,
    conteudoHtml: state.preRegistrations.conteudoHtml,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    handleChangePreRegistration: preRegistration => {
      dispatch(preRegistrationsActions.handleChangePreRegistration(preRegistration))
    },
    setPreRegistrationFormTouched: () => {
      return dispatch(preRegistrationsActions.setPreRegistrationFormTouched())
    },
    getHtmlPreview: preRegistration => {
      return dispatch(preRegistrationsActions.getHtmlPreview(preRegistration))
    },
    changeMessage: ({ message, anchorOrigin }) => {
      dispatch(messageActions.changeMessage({ message, anchorOrigin }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(Livro))



// WEBPACK FOOTER //
// ./src/containers/PreRegistration/PreRegistrationTypes/Livro.js